/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type Workspace_Member = {
    /**
     * ID of the workspace
     */
    workspaceId: string;
    /**
     * ID of the user
     */
    userId: string;
    /**
     * ID of the user
     */
    invitedBy: string | null;
    forename: string;
    username: string;
    email: string;
    surname: string | null;
    position: Workspace_Member.position;
    scopes: Array<any>;
    lastActive: string | null;
    created: string;
    updated: string;
    _object: Workspace_Member._object;
};
export namespace Workspace_Member {
    export enum position {
        OWNER = 'owner',
        ADMIN = 'admin',
        MEMBER = 'member',
        READ_ONLY = 'read-only',
    }
    export enum _object {
        WORKSPACE_MEMBER = 'workspace_member',
    }
}

